import type { Country } from '../country';
import { Cryptocurrency } from '@tectonics/commons/new-payment-methods/commons/cryptocurrency';
import { CreditcardGuatemala } from '@tectonics/commons/new-payment-methods/guatemala/creditcard-guatemala';
import { DebitcardGuatemala } from '@tectonics/commons/new-payment-methods/guatemala/debitcard-guatemala';
import { CashGuatemala } from '@tectonics/commons/new-payment-methods/guatemala/cash-guatemala';
import { guatemalanOutgoingPaymentMapper } from '@tectonics/prs/guatemala/outgoing-payment-mapper';
import { genericDocument } from '@tectonics/commons/customer-form/generic-document';
import { genericPhoneNumber } from '@tectonics/commons/customer-form/generic-phone-number';
import { validateGuatemalanDocument } from '@tectonics/prs/guatemala/validation/guatemalan-document';
import { validateGuatemalanPhoneNumber } from '@tectonics/prs/guatemala/validation/guatemalan-phone-number';
import { LATAM_PHONE_MASK } from '@tectonics/commons/masks';

const GUATEMALA_MASK = [
  /[0-9]/, /[0-9]/, /[0-9]/,
  /[0-9]/, /[0-9]/, /[0-9]/,
  /[0-9]/, /[0-9]/,
];

const GUATEMALA: Country = {
  code: 'gt',
  supportedPaymentMethods: [
    CreditcardGuatemala,
    DebitcardGuatemala,
    CashGuatemala,
    Cryptocurrency,
  ],
  outgoingPaymentMapper: guatemalanOutgoingPaymentMapper,
  customerForm: {
    document: {
      ...genericDocument,
      mask: GUATEMALA_MASK,
      validationFunction: validateGuatemalanDocument,
      inputFieldName: 'guatemalanDocument',
    },
    phoneNumber: {
      ...genericPhoneNumber,
      mask: LATAM_PHONE_MASK,
      validationFunction: validateGuatemalanPhoneNumber,
      inputFieldName: 'guatemalanPhoneNumber',
      placeholderKey: 'volcanes.customerForm.phoneNumber.placeholderLandlineOrMobile',
    },
  },
};

export default GUATEMALA;
